"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Citation = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
exports.Citation = {
  name: 'Citation',
  type: 'standard',
  includeInMetrics: true,
  autoRoutes: ['list', 'create', 'update'],
  canEmbed: true,
  useDuplicateCheck: true,
  groupName: 'Library',
  includeInSearch: true,
  list: {
    resultsVariant: "table",
    hasSearch: true
  },
  filters: {
    fields: {
      authors: {
        entityTypeName: 'Author'
      },
      type: {
        entityTypeName: 'CitationType'
      }
    }
  },
  table: {
    fieldNames: ["info", "slug", "publication", "authors", "volume", "year", "startPage"],
    options: {
      info: {
        title: "Title"
      },
      publication: {
        weight: 2
      },
      slug: {
        weight: 1.5
      }
    }
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      name\n      title \n      url\n      authors { name } \n      editors { name } \n      publisher { name } \n      doi\n      isbn\n      issn\n      issueNumber\n      periodicalName\n      referenceId\n      assessionNumber\n      edition\n      isPeerReviewed\n      pdfUrl\n      keywords { name }\n      publication \n      date \n      accessDate \n      startPage \n      endPage\n      volume \n      footnoteNumber \n      year\n    "], ["\n      name\n      title \n      url\n      authors { name } \n      editors { name } \n      publisher { name } \n      doi\n      isbn\n      issn\n      issueNumber\n      periodicalName\n      referenceId\n      assessionNumber\n      edition\n      isPeerReviewed\n      pdfUrl\n      keywords { name }\n      publication \n      date \n      accessDate \n      startPage \n      endPage\n      volume \n      footnoteNumber \n      year\n    "])))
  },
  form: {
    modal: {
      maxWidth: "1000px",
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'authors'
    }, {
      name: 'specifics'
    }, {
      name: 'titles'
    }, {
      name: 'identification'
    }, {
      name: 'taxonomies'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      name: __assign(__assign({}, create_entity_1.entityStandardFormFields.name), {
        label: 'Title'
      }),
      type: {
        type: 'linked',
        entityTypeName: 'CitationType'
      },
      publication: {
        type: 'text'
      },
      url: {
        type: 'text'
      },
      isPeerReviewed: {
        type: 'boolean'
      },
      pdfUrl: {
        type: 'text',
        recommended: false
      },
      keywords: {
        type: 'linkedMultiple',
        entityTypeName: 'Keyword'
      },
      footnoteNumber: {
        type: 'int',
        recommended: false
      },
      date: {
        fieldSet: 'overview',
        type: 'text',
        recommended: false
      },
      title: {
        fieldSet: 'titles',
        type: 'text'
      },
      secondaryTitle: {
        fieldSet: 'titles',
        type: 'text'
      },
      tertiaryTitle: {
        fieldSet: 'titles',
        type: 'text'
      },
      translatedTitle: {
        fieldSet: 'titles',
        type: 'text'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      description: {
        fieldSet: 'specifics',
        type: 'longText'
      },
      abstract: {
        fieldSet: 'specifics',
        type: 'longText'
      },
      section: {
        fieldSet: 'specifics',
        type: 'text'
      },
      year: {
        fieldSet: 'specifics',
        type: 'int'
      },
      edition: {
        fieldSet: 'specifics',
        type: 'text'
      },
      accessDate: {
        fieldSet: 'specifics',
        type: 'date'
      },
      reprintEdition: {
        fieldSet: 'specifics',
        type: 'text'
      },
      volume: {
        fieldSet: 'specifics',
        type: 'int'
      },
      numberOfVolumes: {
        fieldSet: 'specifics',
        type: 'int'
      },
      startPage: {
        fieldSet: 'specifics',
        type: 'int'
      },
      endPage: {
        fieldSet: 'specifics',
        type: 'int'
      },
      notes: {
        fieldSet: 'specifics',
        type: 'longText'
      },
      authors: {
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Author'
      },
      authorShowsEtAl: {
        label: 'Author Shows Et. Al',
        fieldSet: 'authors',
        type: 'boolean',
        description: 'Show the authors of this citation with the et. al. suffix, meaning \'and others\'. This is used when you don\'t want to exhaustively list all authors involved in the publication.'
      },
      editors: {
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Editor'
      },
      publisher: {
        fieldSet: 'authors',
        type: 'linked',
        entityTypeName: 'Publisher'
      },
      primaryAuthors: {
        label: 'Primary Authors',
        description: 'Who are the primary {{AUTHORS}} for this {{CITATION}}',
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Author'
      },
      secondaryAuthors: {
        label: 'Secondary Authors',
        description: 'Who are the secondary {{AUTHORS}} for this {{CITATION}}',
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Author'
      },
      tertiaryAuthors: {
        label: 'Tertiary Authors',
        description: 'Who are the tertiary {{AUTHORS}} for this {{CITATION}}',
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Author'
      },
      subsidiaryAuthors: {
        label: 'Subsidiary Authors',
        description: 'Who are the subsidiary {{AUTHORS}} for this {{CITATION}}',
        fieldSet: 'authors',
        type: 'linkedMultiple',
        entityTypeName: 'Author'
      },
      doi: {
        fieldSet: 'identification',
        type: 'text'
      },
      isbn: {
        fieldSet: 'identification',
        type: 'text'
      },
      issn: {
        fieldSet: 'identification',
        type: 'text'
      },
      originalPublication: {
        type: 'text',
        fieldSet: 'specifics'
      },
      referenceId: {
        fieldSet: 'identification',
        type: 'text'
      },
      assessionNumber: {
        fieldSet: 'identification',
        type: 'text'
      },
      callNumber: {
        fieldSet: 'identification',
        type: 'text'
      },
      issueNumber: {
        fieldSet: 'identification',
        type: 'text'
      },
      periodicalName: {
        fieldSet: 'periodical',
        type: 'text'
      },
      periodicalNameAbbreviation: {
        fieldSet: 'periodical',
        type: 'text'
      }
    })
  }
};
var templateObject_1;